import Button from "components/button";
import styled from "@emotion/styled";

export const StyledBackButton = styled(Button)`
  margin-bottom: 2rem;
  justify-content: left;
`;
